import { authGet, authGetConditional, authPost, type ConditionalResponse } from "../http_client.js";
import { PrimedResponses } from "../primed_responses.js";
import type {
  ChooseKeyHuntPrizeResponse,
  ClaimKeyHuntPrizeResponse,
  ClaimKeyHuntTaskResponse,
  KeyHuntDebugResponse,
  KeyHuntDto,
  KeyHuntPayloadDto,
} from "../dto/key_hunt.dto.js";

const KEY_HUNT_PATH = "api/player/me/key-hunt?include_locked=1";

export function getKeyHunt(): Promise<KeyHuntPayloadDto>
{
  const primed = PrimedResponses.take<KeyHuntPayloadDto>( "key_hunt" );
  if ( primed ) return Promise.resolve( primed );
  return authGet<KeyHuntPayloadDto>( KEY_HUNT_PATH );
}

export function getKeyHuntConditional( etag: string | null ): Promise<ConditionalResponse<KeyHuntPayloadDto>>
{
  const primed = PrimedResponses.take<KeyHuntPayloadDto>( "key_hunt" );
  if ( primed )
    return Promise.resolve( { status: 200, data: primed, etag: PrimedResponses.take<string | null>( "key_hunt_etag" ) ?? null } );
  return authGetConditional<KeyHuntPayloadDto>( KEY_HUNT_PATH, etag );
}

export function claimKeyHuntTask( task_id: string ): Promise<ClaimKeyHuntTaskResponse>
{
  return authPost<ClaimKeyHuntTaskResponse>( `api/player/me/key-hunt/tasks/${encodeURIComponent( task_id )}/claim` );
}

export function chooseKeyHuntPrize( index: number ): Promise<ChooseKeyHuntPrizeResponse>
{
  return authPost<ChooseKeyHuntPrizeResponse>( "api/player/me/key-hunt/prize/choose", { index } );
}

export function claimKeyHuntPrize(): Promise<ClaimKeyHuntPrizeResponse>
{
  return authPost<ClaimKeyHuntPrizeResponse>( "api/player/me/key-hunt/prize/claim" );
}

export function debugResetKeyHunt(): Promise<KeyHuntDebugResponse>
{
  return authPost<KeyHuntDebugResponse>( "api/player/me/key-hunt/debug/reset" );
}

export function debugCompleteKeyHunt( task_id?: string ): Promise<{ ok: true; key_hunt: KeyHuntDto }>
{
  return authPost<{ ok: true; key_hunt: KeyHuntDto }>( "api/player/me/key-hunt/debug/complete", task_id ? { task_id } : {} );
}

export function debugExpireKeyHunt(): Promise<KeyHuntDebugResponse>
{
  return authPost<KeyHuntDebugResponse>( "api/player/me/key-hunt/debug/expire" );
}
